<template>
  <ul>
    <li
      :class="{'is-float-2':item.config.isFloat===2,'is-float-3':item.config.isFloat===3}"
      :key="index"
      class="w-full"
      contenteditable="false"
      style="margin: 0;"
      v-for="(item, index) in listRight">
      <div :is="getComponents(item)" :iteminfo="item"
           :showButton="false"
           :phoneHeight="phoneHeight"
           style="min-height: 50px"
      ></div>
    </li>
  </ul>
</template>

<script>
import {mapActions} from 'vuex'
import NavDisplayWidget from '../../components/widget/display/NavDisplayWidget'
import MenuDisplayWidget from '../../components/widget/display/MenuDisplayWidget'
import GuideDisplayWidget from '../../components/widget/display/GuideDisplayWidget'
import HotZoneDisplayWidget from '../../components/widget/display/HotZoneDisplayWidget'
import PicDisplayWidget from '../../components/widget/display/PicDisplayWidget'
import VideoDisplayWidget from '../../components/widget/display/VideoDisplayWidget'
import ProductDisplayWidget from '../../components/widget/display/ProductDisplayWidget'
import PersonalInfoDisplayWidget from '../../components/widget/display/PersonalInfoDisplayWidget'
import PhoneDisplayWidget from '../../components/widget/display/PhoneDisplayWidget'
import MineDisplayWidget from '../../components/widget/display/MineDisplayWidget'
import LandingPageDisplayWidget from '../../components/widget/display/LandingPageDisplayWidget'
import DynamicWidget from '../../components/widget/display/DynamicWidget'

export default {
  name: 'PagePrewWidget',
  components: {
    DynamicWidget,
    LandingPageDisplayWidget,
    MineDisplayWidget,
    PhoneDisplayWidget,
    PersonalInfoDisplayWidget,
    ProductDisplayWidget,
    VideoDisplayWidget,
    PicDisplayWidget,
    HotZoneDisplayWidget,
    GuideDisplayWidget,
    MenuDisplayWidget,
    NavDisplayWidget
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    phoneHeight: {
      type: Number,
      default: 0
    }
  },
  watch: {
    id: {
      handler (newValue) {
        if (newValue) {
          this.getPageDetails(newValue)
        } else {
          this.listRight = []
        }
      },
      immediate: true
    },
    phoneHeight: {
      handler (newValue) {
        console.log('prewWidget..' + this.phoneHeight)
        this.listRight.map(item => {
          this.$nextTick(() => {
            if(!item.phoneHeight){
              this.$set(item, 'phoneHeight',this.phoneHeight)
            }
            this.$nextTick(() => {
              item.phoneHeight=this.phoneHeight
            })
          })
        })
      }
    }
  },
  data () {
    return {
      listRight: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    shouldFullScreen (iteminfo) {
      if (iteminfo) {
        if (iteminfo.typeId === 4) {  //图片
          if (iteminfo.config.displayType === 3 && iteminfo.config.subDisplayType === 3) { //4图片3轮播3全屏
            return true
          }
        } else if (iteminfo.typeId === 5) {
          if (iteminfo.config.displayType === 4) {
            return true
          }
        }
      }
      return false
    },
    getComponents (item) {
      let widgetName = ''
      switch (parseInt(item.typeId)) {
        case 2:
          widgetName = 'NavDisplayWidget'
          break
        case 3:
          widgetName = 'MenuDisplayWidget'
          break
        case 4:
          if (item.config.displayType === 3 && item.config.subDisplayType === 3) {//轮播图全屏
            widgetName = 'GuideDisplayWidget'
          } else if (item.config.displayType === 3) {//轮播图片
            widgetName = 'NavDisplayWidget'
          } else if (item.config.displayType === 1) {//图片热区
            widgetName = 'HotZoneDisplayWidget'
          } else {
            widgetName = 'PicDisplayWidget'
          }
          break
        case 5:
          widgetName = 'VideoDisplayWidget'
          break
        case 9:
          widgetName = 'ProductDisplayWidget'
          break
        case 28:
          widgetName = 'PersonalInfoDisplayWidget'
          break
        case 29:
          widgetName = 'PhoneDisplayWidget'
          break
        case 8:
          widgetName = 'GuideDisplayWidget'
          break
        case 11:
          widgetName = 'HotZoneDisplayWidget'
          break
        case 30:
          widgetName = 'MineDisplayWidget'
          break
        case 27:
          widgetName = 'LandingPageDisplayWidget'
          break
        case 18:
          return 'DynamicWidget'
      }
      return widgetName
    },
    getPageDetails (id) {
      this.getPageDetail(id).then(res => {
        if (res.code === 0) {
          let data = res.data
          let containerList = this.getListRightList(data.containerList)
          this.listRight = containerList || []
        }
      })
    },
    getListRightList (datalist) {
      let containerList = []
      containerList = datalist.map(res => {
        let info = {
          id: 0,
          typeId: res.type,
          name: '',
          typename: '',
          config: {
            lrMargin: 0,
            topMargin: 0,
            wBgColor: 'white',
            displayType: 1,
            hasRightAngle: 1,
            hasShadow: 3,
            showMenuTitle: 0,
            menutitle: '',
            datalist: [],
            alignment: 0
          }
        }
        if (res.type === 2) {
          info = this.getNavInfo(res, info)
        } else if (res.type === 3) {
          info = this.getMenuData(res, info)
        } else if (res.type === 4) {
          info = this.getPicData(res, info)
        } else if (res.type === 5) {
          info = this.getVideoInfo(res, info)
        } else if (res.type === 9) {
          info = this.getProductInfo(res, info)
        } else if (res.type === 27) {
          info = this.getLandingPageInfo(res, info)
        } else if (res.type === 29) {
          info = this.getPhoneData(res, info)
        } else if (res.type === 28) {
          info = this.getPersonalInfoData(res, info)
        } else if (res.type === 18) {
          info = this.getDynamicInfo(res, info)
        }
        return info
      })
      return containerList
    },
    /**
     * 解析导航数据
     * @param res
     * @param info
     * @returns {*}
     */
    getNavInfo: function (res, info) {
      let style = JSON.parse(res.style)
      let extension = JSON.parse(res.extension)
      let layout = res.layout
      let mLeft = style.mLeft
      let mTop = style.mTop
      let wBgColor = style.wBgColor
      let showMenuTitle = extension.showMenuTitle || 0
      let menutitle = extension.title || ''
      let spaceLine = extension.hasSpaceLine
      let hasicon = extension.hasIcon || 0
      let isdefault = extension.isDefaultIcon || 0
      let defaultIconColor = extension.defaultIconColor || '#19be6b'
      let alignment = extension.alignment || 0
      let customIcon = extension.iconUrl || ''
      let customBtBgIcon = ''
      let hasBtBgImg = extension.hasBtBgImg || 0
      let titleColor = extension.titleColor || '#333333'
      let titleSize = extension.titleSize || 16
      let showTopBorder = extension.showTopBorder || 0
      let topBorderColor = extension.topBorderColor || '#f1f7fd'
      let topBorderHeight = extension.topBorderHeight || 0
      let btHeight = 40
      let displayType = layout.type
      let rowCount = 1
      let columnCount = 4
      let cardColumnCount = 2
      let imgHeight = 80
      let buttonText = '跳转'
      let buttonBgColor = 'white'
      let buttontextColor = '#333333'
      let buttonTextSize = 14
      let buttonHPadding = 10
      let hasShadow = 0
      let isbold = 0
      let type3Jumpurl = ''
      let hSpacing = 0
      let vSpacing = 0
      let buttonRadius = 0
      let showIcon = 1
      let textAlign = 0
      let ItemBgColor = '#f1f7fd'

      let itemVSpacing = 0
      let itemHSpacing = 0
      let itemContainerColor = ''

      if (displayType === 1) {
        rowCount = extension.rows || 1
        columnCount = extension.columnCount || 4
      } else if (displayType === 2) {
        if (layout.style) {
          let resStyle = JSON.parse(layout.style)
          imgHeight = resStyle.height || 80
          hSpacing = resStyle.hSpacing
          vSpacing = resStyle.vSpacing
        }
        cardColumnCount = extension.columnCount || 2
        rowCount = extension.rows || 1
      } else if (displayType === 3) {
        if (layout.style) {
          let resStyle = JSON.parse(layout.style)
          buttonText = resStyle.btText || '跳转'
          buttonBgColor = resStyle.btBgColor || 'white'
          buttontextColor = resStyle.btTextColor || '#333333'
          buttonTextSize = resStyle.btTextSize || 14
          buttonHPadding = resStyle.btMLeft || 10
          hasShadow = resStyle.btHasShadow || 0
          isbold = resStyle.btIsBold || 0
          customBtBgIcon = resStyle.btBgImg || ''
          btHeight = resStyle.btHeight || 40
          buttonRadius = resStyle.btRadius || 0
        }
      } else if (displayType === 4) {
        if (layout.style) {
          let resStyle = JSON.parse(layout.style)
          imgHeight = resStyle.height || 80
          hSpacing = resStyle.hSpacing || 0
          vSpacing = resStyle.vSpacing || 0
          textAlign = resStyle.align || 0
          ItemBgColor = resStyle.itemBgColor || '#f1f7fd'
        }
        cardColumnCount = extension.columnCount || 2
        rowCount = extension.rows || 1
        showIcon = extension.showIcon

      }
      if (layout.style) {
        let resStyle = JSON.parse(layout.style)
        itemVSpacing = resStyle.itemVSpacing || 0
        itemHSpacing = resStyle.itemHSpacing || 0
        itemContainerColor = resStyle.itemContainerColor || ''
      }
      let contentList = []
      if (res.contentList && res.contentList.length) {
        contentList = res.contentList.map((child, cindex) => {
          let extension = JSON.parse(child.extension)
          let contentLink = ''
          if (child.content && child.content.contentLink) {
            contentLink = child.content.contentLink.link || ''
          }
          let jumpObj = {
            linkUrl: child.jumpLink ? child.jumpLink.link || '' : '',
            linkName: '',
            shareTitle: '',
            shareCover: '',
            showVideoTitle: 0,
            showTime: 0,
            displayType: 1,
            subDisplayType: 1,
            ratio: 2,
            hSpacing: 0,
            vSpacing: 0,
            pSee: 1,
            pPublish: 1,
            pDevices: 1,
            pUsers: [],
            columnCount: 2
          }
          if (extension && extension.jumpObj) {
            jumpObj = extension.jumpObj
          }
          //默认 高/宽 40/100
          let imgInfo = {
            width: 100,
            height: 40
          }
          if (extension && extension.imgInfo) {
            imgInfo = extension.imgInfo
          }
          return {
            id: child.id || 0,
            picurl: child.coverImgUrl || '',
            contentLink: contentLink,
            name: child.name || '',
            jumpObj: jumpObj,
            width: imgInfo.width,
            height: imgInfo.height
          }
        })
      } else {
        if (displayType === 1) {
          if (rowCount > 0 && columnCount > 0) {
            for (let i = 0; i < rowCount * columnCount; i++) {
              contentList.push({
                id: 0,
                picurl: '',
                name: '导航' + (i + 1),
                jumpObj: {
                  linkUrl: '',
                  linkName: '',
                  shareTitle: '',
                  shareCover: '',
                  showVideoTitle: 0,
                  showTime: 0,
                  displayType: 1,
                  subDisplayType: 1,
                  ratio: 2,
                  hSpacing: 10,
                  vSpacing: 10,
                  pSee: 1,
                  pPublish: 1,
                  pDevices: 1,
                  pUsers: [],
                  columnCount: 2
                }
              })
            }
          }
        } else if (displayType === 2 || displayType === 4) {
          if (rowCount > 0 && cardColumnCount > 0) {
            for (let i = 0; i < rowCount * cardColumnCount; i++) {
              contentList.push({
                id: 0,
                picurl: '',
                name: '导航' + (i + 1),
                jumpurl: '',
                jumpObj: {
                  linkUrl: '',
                  linkName: '',
                  shareTitle: '',
                  shareCover: '',
                  showVideoTitle: 0,
                  showTime: 0,
                  displayType: 1,
                  subDisplayType: 1,
                  ratio: 2,
                  hSpacing: 10,
                  vSpacing: 10,
                  pSee: 1,
                  pPublish: 1,
                  pDevices: 1,
                  pUsers: [],
                  columnCount: 2
                }
              })
            }
          }
        }
      }

      info = {
        id: res.id || 0,
        typeId: res.type,
        name: '导航',
        typename: '',
        config: {
          lrMargin: mLeft || 0,
          topMargin: mTop || 0,
          wBgColor: wBgColor,
          showMenuTitle: showMenuTitle,
          spaceLine: spaceLine,
          hasicon: hasicon,
          isdefault: isdefault,
          defaultIconColor: defaultIconColor,
          customIcon: customIcon,
          displayType: displayType || 1,
          rowCount: rowCount,
          columnCount: columnCount,
          buttonText: buttonText || '跳转',
          buttonBgColor: buttonBgColor || 'white',
          buttontextColor: buttontextColor || '#333333',
          buttonTextSize: buttonTextSize || 14,
          buttonHPadding: buttonHPadding || 10,
          customBtBgIcon: customBtBgIcon,
          hasBtBgImg: hasBtBgImg,
          btHeight: btHeight,
          jumpurl: type3Jumpurl,
          hasShadow: hasShadow || 0,
          isbold: isbold || 0,
          imgHeight: imgHeight,
          menutitle: menutitle || '',
          datalist: contentList || [],
          cardColumnCount: cardColumnCount,
          hSpacing: hSpacing,
          vSpacing: vSpacing,
          alignment: alignment,
          buttonRadius: buttonRadius,
          textAlign: textAlign,
          ItemBgColor: ItemBgColor,
          showIcon: showIcon,
          titleColor: titleColor,
          titleSize: titleSize,
          showTopBorder: showTopBorder,
          topBorderColor: topBorderColor,
          topBorderHeight: topBorderHeight,
          itemVSpacing: itemVSpacing,
          itemHSpacing: itemHSpacing,
          itemContainerColor: itemContainerColor,
        }

      }
      return info
    },
    /**
     * 解析菜单数据
     * @param res
     * @param info
     * @returns {*}
     */
    getMenuData: function (res, info) {
      let style = JSON.parse(res.style)
      let extension = JSON.parse(res.extension)
      let layout = res.layout
      let mLeft = style.mLeft
      let mTop = style.mTop
      let wBgColor = style.wBgColor
      let showMenuTitle = extension.showMenuTitle || 0
      let hasShadow = extension.hasShadow || 3
      let displayType = layout.type
      let itemsAlign = extension.itemsAlign || 0
      // let isFullScreen = extension.isFullScreen || 0
      let alignment = extension.alignment || 0
      let titleColor = extension.titleColor || '#333333'
      let titleSize = extension.titleSize || 16
      let showTopBorder = extension.showTopBorder || 0
      let topBorderColor = extension.topBorderColor || '#f1f7fd'
      let topBorderHeight = extension.topBorderHeight || 0
      let itemHeight = 300
      let contentList = []
      if (res.contentList && res.contentList.length) {
        contentList = res.contentList.map(child => {
          let extension = JSON.parse(child.extension)
          let jumpObj = {
            linkUrl: child.jumpLink ? child.jumpLink.link || '' : '',
            linkName: '',
            shareTitle: '',
            shareCover: '',
            showVideoTitle: 0,
            showTime: 0,
            displayType: 1,
            subDisplayType: 1,
            ratio: 2,
            hSpacing: 10,
            vSpacing: 10,
            pSee: 1,
            pPublish: 1,
            pDevices: 1,
            pUsers: [],
            columnCount: 2
          }
          if (extension && extension.jumpObj) {
            jumpObj = extension.jumpObj
          }
          return {
            id: child.id || 0,
            picurl: '',
            name: child.name || '',
            jumpurl: child.jumpLink ? child.jumpLink.link || '' : '',
            contentType: 1,
            jumpObj: jumpObj,
            imgList: []
          }
        })
      } else {
        for (let i = 0; i < 2; i++) {
          contentList.push({
            name: '菜单' + (i + 1),
            jumpurl: '',
            contentType: 1,
            jumpObj: {
              linkUrl: '',
              linkName: '',
              shareTitle: '',
              shareCover: '',
              showVideoTitle: 0,
              showTime: 0,
              displayType: 1,
              subDisplayType: 1,
              ratio: 2,
              hSpacing: 10,
              vSpacing: 10,
              pSee: 1,
              pPublish: 1,
              pDevices: 1,
              pUsers: [],
              columnCount: 2
            },
            imgList: []
          })
        }
      }

      let fontcolor = '#399DFF'
      let unfontcolor = '#333333'
      let menuBgColor = 'white'
      let itemVSpacing = 0
      let itemHSpacing = 0
      let itemContainerColor = ''
      if (layout.style) {
        let resStyle = JSON.parse(layout.style)
        fontcolor = resStyle.chooseColor || '#399DFF'
        unfontcolor = resStyle.themeColor || '#333333'
        menuBgColor = resStyle.menuBgColor || 'white'
        itemHeight = resStyle.itemHeight || 300
        itemVSpacing = resStyle.itemVSpacing || 0
        itemHSpacing = resStyle.itemHSpacing || 0
        itemContainerColor = resStyle.itemContainerColor || ''
      }
      info = {
        id: res.id || 0,
        typeId: res.type,
        name: '菜单',
        config: {
          lrMargin: mLeft || 0,
          topMargin: mTop || 0,
          wBgColor: wBgColor,
          showMenuTitle: showMenuTitle,
          spaceLine: 1,
          hasicon: 0,
          isdefault: 0,
          defaultIconColor: '#19be6b',
          customIcon: '',
          displayType: displayType || 1,
          itemsAlign: itemsAlign,
          // isFullScreen: isFullScreen,
          customHeight: itemHeight,
          hasShadow: hasShadow || 0,
          menutitle: '',
          datalist: contentList || [],
          fontcolor: fontcolor || '#399DFF',
          unfontcolor: unfontcolor || '#333333',
          menuBgColor: menuBgColor || 'white',
          alignment: alignment,
          titleColor: titleColor,
          titleSize: titleSize,
          showTopBorder: showTopBorder,
          topBorderColor: topBorderColor,
          topBorderHeight: topBorderHeight,
          itemVSpacing: itemVSpacing,
          itemHSpacing: itemHSpacing,
          itemContainerColor: itemContainerColor,
        }

      }
      return info
    },
    /**
     * 解析图片数据
     * @param res
     * @param info
     * @returns {*}
     */
    getPicData: function (res, info) {
      let style = JSON.parse(res.style)
      let extension = JSON.parse(res.extension)
      let layout = res.layout
      let mLeft = style.mLeft
      let mTop = style.mTop
      let wBgColor = style.wBgColor
      let showMenuTitle = extension.showMenuTitle || 0
      let autoTurn = extension.autoTurn || 0
      let showDots = extension.showDots || 0
      let contentType = res.contentType || 0
      let linkUrl = res.contentLink ? res.contentLink.link || '' : ''
      let hasShadow = extension.hasShadow || 3
      let menutitle = extension.title || ''
      let spaceLine = extension.hasSpaceLine
      let hasicon = extension.hasIcon || 0
      let isdefault = extension.isDefaultIcon || 0
      let defaultIconColor = extension.defaultIconColor || '#19be6b'
      let hOrientation = extension.hOrientation
      let isAutoHeight = extension.isAutoHeight
      let columnCount = extension.columnCount || 2
      let customIcon = extension.iconUrl || ''
      let alignment = extension.alignment || 0
      let rowCount = extension.rowCount
      let ratio = extension.ratio || 4

      let titleColor = extension.titleColor || '#333333'
      let titleSize = extension.titleSize || 16
      let showTopBorder = extension.showTopBorder || 0
      let topBorderColor = extension.topBorderColor || '#f1f7fd'
      let topBorderHeight = extension.topBorderHeight || 0
      // let isFullScreen = extension.isFullScreen || false
      let displayType = layout.type
      let imgHeight = 176
      let imgWidth = 176
      let hSpacing = 0
      let vSpacing = 0
      let subDisplayType = 1
      let itemVSpacing = 0
      let itemHSpacing = 0
      let itemContainerColor = ''

      //是否显示跳转连接设置
      let isNav = false
      let urlObj = extension.urlObj || {
        linkUrl: '',
        linkName: '',
        shareTitle: '',
        shareCover: '',
        showVideoTitle: 0,
        showTime: 0,
        displayType: 1,
        subDisplayType: 1,
        ratio: 2,
        hSpacing: 0,
        vSpacing: 0,
        pSee: 1,
        pPublish: 1,
        pDevices: 1,
        pUsers: [],
        columnCount: 2
      }
      this.$set(urlObj, 'linkUrl', linkUrl)
      if (layout.style) {
        let resStyle = JSON.parse(layout.style)
        imgHeight = resStyle.height || 176
        imgWidth = resStyle.width || 176
        hSpacing = resStyle.hSpacing
        vSpacing = resStyle.vSpacing
        subDisplayType = resStyle.subDisplayType
        itemVSpacing = resStyle.itemVSpacing || 0
        itemHSpacing = resStyle.itemHSpacing || 0
        itemContainerColor = resStyle.itemContainerColor || ''
        isNav = resStyle.isNav
      }
      let lineLimit = isNav ? 0 : extension.lineLimit || 1
      let contentList = []
      if (res.contentList && res.contentList.length) {
        contentList = res.contentList.map(child => {
          let id = child.id || 0
          let cid = 0
          let ccid = 0
          let cccid = 0
          let title = ''
          let picurl = ''
          let contentLink = ''
          let width = 0
          let height = 0
          if (child.content) {
            let content1 = child.content
            cid = content1.id
            if (content1.descList && content1.descList.length) {
              let descListItem = content1.descList[0]
              ccid = descListItem.id
              if (descListItem) {
                title = descListItem.desc || ''
                picurl = descListItem.imgUrl || ''
                width = descListItem.width || 0
                height = descListItem.height || 0
                cccid = descListItem.id || 0
              }
            }
            if (content1.contentLink) {
              contentLink = content1.contentLink.link || ''
            }
          }
          let zones = []
          if (child.hotspotList && child.hotspotList.length) {
            zones = child.hotspotList.map(rchild => {
              let style = JSON.parse(rchild.style)
              let extension = rchild.extension ? JSON.parse(rchild.extension) : ''
              let jumpObj = {
                linkUrl: rchild.jumpLink ? rchild.jumpLink.link || '' : '',
                linkName: '',
                shareTitle: '',
                shareCover: '',
                showVideoTitle: 0,
                showTime: 0,
                displayType: 1,
                subDisplayType: 1,
                ratio: 2,
                hSpacing: 0,
                vSpacing: 0,
                pSee: 1,
                pPublish: 1,
                pDevices: 1,
                pUsers: [],
                columnCount: 2
              }
              if (extension && extension.jumpObj) {
                jumpObj = extension.jumpObj
              }
              return {
                id: rchild.id,
                topPer: style.top || 0,
                leftPer: style.left || 0,
                widthPer: style.width || 0,
                heightPer: style.height || 0,
                url: rchild.jumpLink ? rchild.jumpLink.link || '' : '',
                jumpObj: jumpObj
              }
            })
          }
          let extension = child.extension ? JSON.parse(child.extension) : ''
          let jumpObj = {
            linkUrl: child.jumpLink ? child.jumpLink.link || '' : '',
            linkName: child.jumpObj ? child.jumpObj.linkName ? child.jumpObj.linkName : '' : '',
            shareTitle: '',
            shareCover: '',
            showVideoTitle: 0,
            showTime: 0,
            displayType: 1,
            subDisplayType: 1,
            ratio: 2,
            hSpacing: 0,
            vSpacing: 0,
            pSee: 1,
            pPublish: 1,
            pDevices: 1,
            pUsers: [],
            columnCount: 2
          }
          if (extension && extension.jumpObj) {
            jumpObj = extension.jumpObj
          }
          let info = {
            id: id,
            cid: cid,
            ccid: ccid,
            cccid: cccid,
            title: title,
            picurl: picurl,
            contentLink: contentLink,
            jumpurl: child.jumpLink ? child.jumpLink.link || '' : '',
            width: width,
            height: height,
            zones: zones || [],
            jumpObj: jumpObj
          }
          return info
        })
        if (displayType === 1) {
          contentList = contentList.slice(0, 1)
        }
      } else {
        this.$Message.info('数据为空')
        // if (displayType === 1) {
        //   contentList = [{
        //     id: 0,
        //     cid: 0,
        //     ccid: 0,
        //     cccid: 0,
        //     title: '',
        //     picurl: '',
        //     jumpurl: '',
        //     width: 820,
        //     height: 461,
        //     zones: [],
        //     jumpObj: {
        //       linkUrl: '',
        //       linkName: '',
        //       shareTitle: '',
        //       shareCover: '',
        //       showVideoTitle: 0,
        //       showTime: 0,
        //       displayType: 1,
        //       subDisplayType: 1,
        //       ratio: 2,
        //       hSpacing: 0,
        //       vSpacing: 0,
        //       pSee: 1,
        //       pPublish: 1,
        //       pDevices: 1,
        //       pUsers: [],
        //       columnCount: 2
        //     }
        //   }]
        // }
        // else if (displayType === 2) {
        //   let temprowCount = rowCount
        //   let templineLimit = lineLimit
        //   let columnCountNum = parseInt(columnCount) > 0 ? parseInt(columnCount) : 1
        //   let length = 6
        //   if (templineLimit === 1) {
        //     length = temprowCount * columnCountNum
        //   }
        //   for (let i = 0; i < length; i++) {
        //     contentList.push({
        //       id: 0,
        //       cid: 0,
        //       ccid: 0,
        //       cccid: 0,
        //       title: '',
        //       picurl: '',
        //       jumpurl: '',
        //       width: 820,
        //       height: 461,
        //       zones: [],
        //       jumpObj: {
        //         linkUrl: '',
        //         linkName: '',
        //         shareTitle: '',
        //         shareCover: '',
        //         showVideoTitle: 0,
        //         showTime: 0,
        //         displayType: 1,
        //         subDisplayType: 1,
        //         ratio: 2,
        //         hSpacing: 0,
        //         vSpacing: 0,
        //         pSee: 1,
        //         pPublish: 1,
        //         pDevices: 1,
        //         pUsers: [],
        //         columnCount: 2
        //       }
        //     })
        //   }
        // }
        // else {
        //   for (let i = 0; i < 4; i++) {
        //     contentList.push({
        //       id: 0,
        //       cid: 0,
        //       ccid: 0,
        //       cccid: 0,
        //       title: '',
        //       picurl: '',
        //       jumpurl: '',
        //       width: 820,
        //       height: 461,
        //       zones: [],
        //       jumpObj: {
        //         linkUrl: '',
        //         linkName: '',
        //         shareTitle: '',
        //         shareCover: '',
        //         showVideoTitle: 0,
        //         showTime: 0,
        //         displayType: 1,
        //         subDisplayType: 1,
        //         ratio: 2,
        //         hSpacing: 0,
        //         vSpacing: 0,
        //         pSee: 1,
        //         pPublish: 1,
        //         pDevices: 1,
        //         pUsers: [],
        //         columnCount: 2
        //       }
        //     })
        //   }
        // }

      }

      info = {
        id: res.id || 0,
        typeId: res.type,
        name: '图片',
        config: {
          topMargin: mTop || 0,
          lrMargin: mLeft || 0,
          wBgColor: wBgColor,
          displayType: displayType || 1,
          subDisplayType: subDisplayType || 1,
          showMenuTitle: showMenuTitle,
          hasShadow: 3,
          hasRightAngle: 1,
          spaceLine: spaceLine,
          hasicon: hasicon,
          isdefault: isdefault,
          customIcon: customIcon,
          defaultIconColor: defaultIconColor,
          menutitle: menutitle || '',
          columnCount: columnCount,
          isNav: isNav || false,
          // isFullScreen: isFullScreen|| false,
          datalist: contentList || [],
          marginSpace: 0,
          alignment: alignment,
          hOrientation: hOrientation,
          autoHeight: isAutoHeight,
          hSpacing: hSpacing,
          vSpacing: vSpacing,
          imgWidth: imgWidth,
          imgHeight: imgHeight,
          ratio: ratio,
          lineLimit: lineLimit,
          rowCount: rowCount,
          contentType: contentType,
          linkUrl: linkUrl,
          // showPicTitle: 1,
          // picTitlePosition: 1,
          titleColor: titleColor,
          titleSize: titleSize,
          showTopBorder: showTopBorder,
          topBorderColor: topBorderColor,
          topBorderHeight: topBorderHeight,
          itemVSpacing: itemVSpacing,
          itemHSpacing: itemHSpacing,
          itemContainerColor: itemContainerColor,
          autoTurn: autoTurn,
          showDots: showDots,
          jumpObj: urlObj
        }
      }
      return info
    },


    /**
     * 解析视频数据
     * @param res
     * @param info
     * @returns {*}
     */
    getVideoInfo: function (res, info) {
      let style = JSON.parse(res.style)
      let extension = JSON.parse(res.extension)
      let layout = res.layout
      let mLeft = style.mLeft
      let mTop = style.mTop
      let wBgColor = style.wBgColor
      let showMenuTitle = extension.showMenuTitle || 0
      let pagePlay = extension.pagePlay || 0
      let contentType = res.contentType
      let linkUrl = res.contentLink ? res.contentLink.link || '' : ''
      let hasShadow = extension.hasShadow || 3
      let menutitle = extension.title || ''
      let spaceLine = extension.hasSpaceLine
      let hasicon = extension.hasIcon || 0
      let isdefault = extension.isDefaultIcon || 1
      let defaultIconColor = extension.defaultIconColor || '#19be6b'
      let columnCount = extension.columnCount || 1
      let customIcon = extension.iconUrl || ''
      let alignment = extension.alignment || 0
      let titleColor = extension.titleColor || '#333333'
      let titleSize = extension.titleSize || 16
      let showTopBorder = extension.showTopBorder || 0
      let topBorderColor = extension.topBorderColor || '#f1f7fd'
      let topBorderHeight = extension.topBorderHeight || 0
      let imgHeight = 176
      let hSpacing = 10
      let vSpacing = 10
      let displayType = layout.type || 1
      let lineLimit = extension.lineLimit
      let rowCount = extension.rowCount
      let ratio = extension.ratio
      let subDisplayType = 1
      let itemVSpacing = 0
      let itemHSpacing = 0
      let itemContainerColor = ''
      let urlObj = extension.urlObj || {
        linkUrl: '',
        linkName: '',
        shareTitle: '',
        shareCover: '',
        showVideoTitle: 0,
        showTime: 0,
        displayType: 1,
        subDisplayType: 1,
        ratio: 2,
        hSpacing: 0,
        vSpacing: 0,
        pSee: 1,
        pPublish: 1,
        pDevices: 1,
        pUsers: [],
        columnCount: 2
      }
      this.$set(urlObj, 'linkUrl', linkUrl)
      // urlObj.linkUrl = linkUrl
      if (layout.style) {
        let resStyle = JSON.parse(layout.style)
        imgHeight = resStyle.height || 176
        hSpacing = resStyle.hSpacing
        vSpacing = resStyle.vSpacing
        subDisplayType = resStyle.subDisplayType
        itemVSpacing = resStyle.itemVSpacing || 0
        itemHSpacing = resStyle.itemHSpacing || 0
        itemContainerColor = resStyle.itemContainerColor || ''
      }
      let showVideoTitle = extension.showVideoTitle || 0
      let showTime = extension.showTime || 0
      let contentList = []
      if (res.contentList && res.contentList.length) {
        contentList = res.contentList.map(child => {
          let id = child.id || 0
          let cid = 0
          let ccid = 0
          let cccid = 0
          let title = ''
          let sourceUrl = ''
          let videourl = ''
          let contentLink = ''
          let coverContentLink = ''
          let coverImgUrl = ''
          if (child.content) {
            let content1 = child.content
            cid = content1.id
            if (content1.descList && content1.descList.length) {
              let descListItem = content1.descList[0]
              ccid = descListItem.id
              if (descListItem) {
                title = descListItem.title || ''
                sourceUrl = descListItem.sourceUrl || ''
                videourl = descListItem.videoUrl || ''
                cccid = descListItem.id || 0
                coverImgUrl = descListItem.coverImgUrl || descListItem.imgUrl || ''
              }
            }
            if (content1.contentLink) {
              contentLink = content1.contentLink.link || ''
            }
            if (content1.coverContentLink) {
              coverContentLink = content1.coverContentLink.link || ''
            }
          }
          let info = {
            id: id,
            cid: cid,
            ccid: ccid,
            cccid: cccid,
            videoTitle: title,
            coverImgUrl: coverImgUrl || '',
            mp4Url: sourceUrl,
            videoUrl: videourl,
            contentLink: contentLink,
            coverContentLink: coverContentLink,
            jumpurl: child.jumpLink ? child.jumpLink.link || '' : '',
            content: {
              content: ''
            },
            jumpObj: urlObj
          }
          return info
        })
      }
      // else {
      //   if (displayType === 2 || displayType === 3) {
      //     let row = 4
      //     if (lineLimit === 1) {
      //       row = rowCount || 1
      //       for (let i = 0; i < row; i++) {
      //         contentList.push({
      //           videoUrl: '',
      //           mp4Url: '',
      //           videoTitle: '',
      //           jumpurl: '',
      //           content: {
      //             content: ''
      //           },
      //           jumpObj: urlObj
      //         })
      //       }
      //     } else {
      //       for (let i = 0; i < row; i++) {
      //         contentList.push({
      //           videoUrl: '',
      //           mp4Url: '',
      //           videoTitle: '',
      //           jumpurl: '',
      //           content: {
      //             content: ''
      //           }
      //         })
      //       }
      //     }
      //   } else if (displayType === 1) {
      //     let row = 4
      //     let length = row * 2
      //     if (lineLimit === 1) {
      //       row = rowCount || 1
      //       length = row * 2
      //       for (let i = 0; i < length; i++) {
      //         contentList.push({
      //           videoUrl: '',
      //           mp4Url: '',
      //           videoTitle: '',
      //           jumpurl: '',
      //           content: {
      //             content: ''
      //           },
      //           jumpObj: urlObj
      //         })
      //       }
      //     } else {
      //       for (let i = 0; i < length; i++) {
      //         contentList.push({
      //           videoUrl: '',
      //           mp4Url: '',
      //           videoTitle: '',
      //           jumpurl: '',
      //           content: {
      //             content: ''
      //           }
      //         })
      //       }
      //     }
      //   } else if (displayType === 4) {
      //     for (let i = 0; i < 4; i++) {
      //       contentList.push({
      //         videoUrl: '',
      //         mp4Url: '',
      //         videoTitle: '',
      //         jumpurl: '',
      //         content: {
      //           content: ''
      //         },
      //         jumpObj: urlObj
      //       })
      //     }
      //   }
      // }

      info = {
        id: res.id || 0,
        typeId: res.type,
        name: '视频',
        config: {
          topMargin: mTop || 0,
          lrMargin: mLeft || 0,
          wBgColor: wBgColor,
          displayType: displayType || 1,
          subDisplayType: subDisplayType || 1,
          showMenuTitle: showMenuTitle,
          hasShadow: 3,
          hasRightAngle: 1,
          spaceLine: spaceLine,
          hasicon: hasicon,
          isdefault: isdefault,
          alignment: alignment,
          customIcon: customIcon,
          defaultIconColor: defaultIconColor,
          menutitle: menutitle || '',
          columnCount: columnCount,
          pagePlay: pagePlay,
          videoHeight: imgHeight,
          hSpacing: hSpacing,
          vSpacing: vSpacing,
          datalist: contentList || [],
          ratio: ratio,
          lineLimit: lineLimit,
          rowCount: rowCount,
          showPicTitle: 1,
          titleColor: titleColor,
          titleSize: titleSize,
          showVideoTitle: showVideoTitle,
          showTime: showTime,
          showTopBorder: showTopBorder,
          topBorderColor: topBorderColor,
          topBorderHeight: topBorderHeight,
          itemVSpacing: itemVSpacing,
          itemHSpacing: itemHSpacing,
          itemContainerColor: itemContainerColor,
          contentType: contentType,
          jumpObj: urlObj,
          haslimit: lineLimit || 0
        },
      }
      return info
    },

    /**
     * 解析商品组件返回数据
     * @param datalist
     * @returns {Array}
     */
    getProductInfo: function (res, info) {
      let style = JSON.parse(res.style)
      let extension = JSON.parse(res.extension)
      let layout = res.layout
      let mLeft = style.mLeft
      let mTop = style.mTop
      let wBgColor = style.wBgColor
      let showMenuTitle = extension.showMenuTitle || 0
      let linkUrl = res.contentLink ? res.contentLink.link || '' : ''
      let menutitle = extension.title || ''
      let spaceLine = extension.hasSpaceLine
      let hasicon = extension.hasIcon || 0
      let isdefault = extension.isDefaultIcon || 1
      let defaultIconColor = extension.defaultIconColor || '#19be6b'
      let customIcon = extension.iconUrl || ''
      let rowCount = extension.rowCount
      let lineLimit = extension.lineLimit
      let alignment = extension.alignment || 0
      let showPrice = extension.showPrice || 0
      let titleColor = extension.titleColor || '#333333'
      let titleSize = extension.titleSize || 16
      let showTopBorder = extension.showTopBorder || 0
      let topBorderColor = extension.topBorderColor || '#f1f7fd'
      let topBorderHeight = extension.topBorderHeight || 0
      let ratio = extension.ratio || 2
      let hSpacing = 10
      let vSpacing = 10

      let itemVSpacing = 0
      let itemHSpacing = 0
      let itemContainerColor = ''
      let displayType = layout.type || 1
      let urlObj = extension.urlObj || {
        linkName: '',
        shareTitle: '',
        shareCover: '',
        showVideoTitle: 0,
        showTime: 0,
        displayType: 1,
        ratio: 2,
        hSpacing: 0,
        vSpacing: 0,
        pSee: 1,
        pPublish: 1,
        pDevices: 1,
        pUsers: [],
        columnCount: 2
      }
      this.$set(urlObj, 'linkUrl', linkUrl)
      let subDisplayType = 1
      if (layout.style) {
        let resStyle = JSON.parse(layout.style)
        hSpacing = resStyle.hSpacing || 10
        vSpacing = resStyle.vSpacing || 10
        subDisplayType = resStyle.subDisplayType
        itemVSpacing = resStyle.itemVSpacing || 0
        itemHSpacing = resStyle.itemHSpacing || 0
        itemContainerColor = resStyle.itemContainerColor || ''
      }

      info = {
        id: res.id || 0,
        typeId: res.type,
        name: '商品',
        config: {
          topMargin: mTop || 0,
          lrMargin: mLeft || 0,
          wBgColor: wBgColor,
          showMenuTitle: showMenuTitle,
          spaceLine: spaceLine,
          hasicon: hasicon,
          isdefault: isdefault,
          alignment: alignment,
          customIcon: customIcon,
          defaultIconColor: defaultIconColor,
          menutitle: menutitle || '',
          displayType: displayType,
          ratio: 1,
          subDisplayType: subDisplayType,
          contentType: 1,
          titleColor: titleColor,
          titleSize: titleSize,
          showNum: rowCount,
          haslimit: lineLimit,
          showPrice: showPrice,
          datalist: [],
          hSpacing: hSpacing,
          vSpacing: vSpacing,
          showTopBorder: showTopBorder,
          topBorderColor: topBorderColor,
          topBorderHeight: topBorderHeight,
          itemVSpacing: itemVSpacing,
          itemHSpacing: itemHSpacing,
          itemContainerColor: itemContainerColor,
          jumpObj: urlObj,
        }
      }
      return info
    },

    /**
     * 解析电话组件返回数据
     * @param datalist
     * @returns {Array}
     */
    getPhoneData: function (res, info) {

      let style = JSON.parse(res.style)
      let extension = JSON.parse(res.extension)
      let layout = res.layout
      let layoutStyle = JSON.parse(layout.style)

      let mLeft = style.mLeft
      let mTop = style.mTop
      let wBgColor = style.wBgColor
      let showMenuTitle = extension.showMenuTitle || 0
      let linkUrl = res.contentLink ? res.contentLink.link || '' : ''
      let menutitle = extension.title || ''
      let spaceLine = extension.hasSpaceLine
      let hasicon = extension.hasIcon || 0
      let isdefault = extension.isDefaultIcon || 1
      let defaultIconColor = extension.defaultIconColor || '#19be6b'
      let customIcon = extension.iconUrl || ''
      let rowCount = extension.rowCount
      let lineLimit = extension.lineLimit
      let alignment = extension.alignment || 0
      let showPrice = extension.showPrice || 0
      let titleColor = extension.titleColor || '#333333'
      let titleSize = extension.titleSize || 16
      let showTopBorder = extension.showTopBorder || 0
      let topBorderColor = extension.topBorderColor || '#f1f7fd'
      let topBorderHeight = extension.topBorderHeight || 0
      let ratio = extension.ratio || 2
      let hSpacing = 10
      let vSpacing = 10

      let itemVSpacing = 0
      let itemHSpacing = 0
      let itemContainerColor = ''
      let displayType = layout.type || 1
      if (layout.style) {
        let resStyle = JSON.parse(layout.style)
        hSpacing = resStyle.hSpacing || 10
        vSpacing = resStyle.vSpacing || 10
        itemVSpacing = resStyle.itemVSpacing || 0
        itemHSpacing = resStyle.itemHSpacing || 0
        itemContainerColor = resStyle.itemContainerColor || ''
      }

      let contentList = []
      if (res.contentList) {
        contentList = res.contentList.map(child => {
          if (child.content) {
            return {
              phone: child.content.phone || ''
            }
          }
          return {
            phone: ''
          }
        })
      }

      info = {
        typeId: res.type,
        typename: '其他',
        name: '电话组件',
        icon: require('../../assets/tempmenu/ic_other_phone@2x.png'),
        coverImgUrl: '',
        config: {
          'btBgColor': layoutStyle.btBgColor || '#3B80FF',
          'btTextColor': layoutStyle.btTextColor || '#FFFFFF',
          'btHeight': layoutStyle.btHeight || 30,
          'btRadius': layoutStyle.btRadius || 4,
          'btText': extension.btText,
          'itemVSpacing': 0,
          'itemHSpacing': 0,
          'isFloat': extension.isFloat,
          'btBgImg': extension.btBgImg,

          'topMargin': 0,
          'lrMargin': 0,
          'displayType': 1,
          'subDisplayType': 1,
          'datalist': contentList || [],
          'hSpacing': 0,
          'vSpacing': 0,
          'width': extension.width,
          'height': extension.height,
          'contentType': 0,
        },
      }
      return info
    },

    /**
     * 解析线索组件返回数据
     */
    getPersonalInfoData: function (res, info) {
      let style = JSON.parse(res.style)
      let extension = JSON.parse(res.extension)
      let layout = res.layout
      let layoutStyle = JSON.parse(layout.style)

      let mLeft = style.mLeft
      let mTop = style.mTop
      let wBgColor = style.wBgColor
      let showMenuTitle = extension.showMenuTitle || 0
      let linkUrl = res.contentLink ? res.contentLink.link || '' : ''
      let menutitle = extension.title || ''
      let spaceLine = extension.hasSpaceLine
      let hasicon = extension.hasIcon || 0
      let isdefault = extension.isDefaultIcon || 1
      let defaultIconColor = extension.defaultIconColor || '#19be6b'
      let customIcon = extension.iconUrl || ''
      let rowCount = extension.rowCount
      let lineLimit = extension.lineLimit
      let alignment = extension.alignment || 0
      let showPrice = extension.showPrice || 0
      let titleColor = extension.titleColor || '#333333'
      let titleSize = extension.titleSize || 16
      let showTopBorder = extension.showTopBorder || 0
      let topBorderColor = extension.topBorderColor || '#f1f7fd'
      let topBorderHeight = extension.topBorderHeight || 0
      let ratio = extension.ratio || 2
      let hSpacing = 10
      let vSpacing = 10

      let itemVSpacing = 0
      let itemHSpacing = 0
      let itemContainerColor = ''
      let displayType = layout.type || 1
      if (layout.style) {
        let resStyle = JSON.parse(layout.style)
        hSpacing = resStyle.hSpacing || 10
        vSpacing = resStyle.vSpacing || 10
        itemVSpacing = resStyle.itemVSpacing || 0
        itemHSpacing = resStyle.itemHSpacing || 0
        itemContainerColor = resStyle.itemContainerColor || ''
      }

      let contentList = []
      if (res.contentList) {
        contentList = res.contentList.map(child => {
          return {
            id: child.content.id,
            type: child.content.type,
            name: child.name,
            isShow: child.content.isShow,
            sort: child.sort,
          }
        })
      }

      info = {

        typeId: res.type,
        typename: '其他',
        name: '线索组件',
        icon: require('../../assets/tempmenu/ic_other_phone@2x.png'),
        config: {
          'btBgColor': layoutStyle.btBgColor || '#3B80FF',
          'btTextColor': layoutStyle.btTextColor || '#FFFFFF',
          'btHeight': layoutStyle.btHeight || 30,
          'btRadius': layoutStyle.btRadius || 4,
          'btText': extension.btText,
          'itemVSpacing': 0,
          'itemHSpacing': 0,
          'topMargin': 0,
          'lrMargin': 0,
          'datalist': contentList || [],
          'hSpacing': 0,
          'vSpacing': 0,
          // 'width': extension.width,
          // 'height': extension.height,
          'contentType': 0,
          'wBgColor': wBgColor || 'white'
        },
      }
      return info
    },

    /**
     * 解析动态数据
     * */
    getDynamicInfo: function (res, info) {
      let style = JSON.parse(res.style)
      let extension = JSON.parse(res.extension)
      let layout = res.layout
      let mLeft = style.mLeft
      let mTop = style.mTop
      let wBgColor = style.wBgColor
      let showMenuTitle = extension.showMenuTitle || 0
      let linkUrl = res.contentLink ? res.contentLink.link || '' : ''
      let menutitle = extension.title || ''
      let spaceLine = extension.hasSpaceLine
      let hasicon = extension.hasIcon || 0
      let isdefault = extension.isDefaultIcon || 1
      let defaultIconColor = extension.defaultIconColor || '#19be6b'
      let hasComment = extension.hasComment || 1
      let haslimit = extension.lineLimit || 0
      let rowCount = extension.rowCount || 2
      let customIcon = extension.iconUrl || ''
      let alignment = extension.alignment || 0
      let titleColor = extension.titleColor || '#333333'
      let titleSize = extension.titleSize || 16
      let showTopBorder = extension.showTopBorder || 0
      let topBorderColor = extension.topBorderColor || '#f1f7fd'
      let topBorderHeight = extension.topBorderHeight || 0
      let itemVSpacing = 0
      let itemHSpacing = 0
      let hSpacing = 14
      let vSpacing = 0
      let itemContainerColor = ''
      let displayType = layout.type || 1
      let urlObj = extension.urlObj || {
        linkUrl: '',
        linkName: '',
        shareTitle: '',
        shareCover: '',
        showVideoTitle: 0,
        showTime: 0,
        displayType: 1,
        subDisplayType: 1,
        ratio: 2,
        hSpacing: 10,
        vSpacing: 5,
        pSee: 1,
        pPublish: 1,
        pDevices: 1,
        pUsers: [],
        columnCount: 2
      }
      // this.$set(urlObj, 'linkUrl', linkUrl)
      // urlObj.linkUrl = linkUrl
      if (layout.style) {
        let resStyle = JSON.parse(layout.style)
        itemVSpacing = resStyle.itemVSpacing || 0
        itemHSpacing = resStyle.itemHSpacing || 0
        hSpacing = resStyle.hSpacing
        vSpacing = resStyle.vSpacing
        itemContainerColor = resStyle.itemContainerColor || ''
      }
      info = {
        id: res.id || 0,
        typeId: res.type,
        name: '论坛',
        config: {
          topMargin: mTop || 0,
          lrMargin: mLeft || 0,
          wBgColor: wBgColor,
          showMenuTitle: showMenuTitle,
          spaceLine: spaceLine,
          hasicon: hasicon,
          isdefault: isdefault,
          alignment: alignment,
          customIcon: customIcon,
          defaultIconColor: defaultIconColor,
          displayType: displayType,
          menutitle: menutitle || '',
          contentType: 1,
          linkUrl: linkUrl,
          titleColor: titleColor,
          titleSize: titleSize,
          hSpacing: hSpacing,
          vSpacing: vSpacing,
          datalist: [],
          showTopBorder: showTopBorder,
          topBorderColor: topBorderColor,
          topBorderHeight: topBorderHeight,
          itemVSpacing: itemVSpacing,
          itemHSpacing: itemHSpacing,
          itemContainerColor: itemContainerColor,
          hasComment: hasComment,
          jumpObj: urlObj,
          haslimit: haslimit,
          showNum: rowCount,
        }
      }
      return info
    },

    ...mapActions([
      'getPageDetail',
    ])
  }
}
</script>

<style lang="scss" scoped>

.is-float-2 {
  position: absolute;
  bottom: 2px;
  width: 375px; //屏幕宽度
}

.is-float-3 {
  position: absolute;
  bottom: 60px;
  width: 375px; //屏幕宽度
}
</style>
